import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Loader } from '../common/Loader';
import { Row, Col, Container } from 'reactstrap';
import TeSelect from '../forms/TeSelect';
import TeInput from '../forms/TeInput';
import { getYokeDesignData, setYokeDesignData, updateYokeDesign } from '../../actions/DesignMaster';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { checkForNull, loggedInUserId } from '../../helper';
import moment from 'moment';
import { onKeyPress } from '../../config/config';

const YokeDesign = ({
    setYokeDesignData,
    getYokeDesignData,
    updateYokeDesign,
    ShutterId,
    isEditFlag,
    toggle,
    resetTabs,
    data,
    isViewFlag,
    shutterIdNewCreated,
    ...props }) => {
    const {
        client,
        project,
        location,
        tag_number,
        rev_number,
        rev_date,
        date,
        selectedSpindleType,
        applicableStandard,
        safetyFactor,
        criticalBulkingForce,
        electricallyHoistingCapacity,
        manuallyHoistingCapacity,
        selectedActuation,
        shutterDesignId,
    } = data;
    const width = parseFloat(data.width);
    const [isLoader, setLoader] = useState(false);
    const [materialOfConstruction, setMaterialOfConstruction] = useState('');
    const [yokeSection, setYokeSection] = useState('');
    const [thicknessOfSection, setThicknessOfSection] = useState('');
    const [case1L, setCase1L] = useState(0);
    const [selectedBoltMaterial, setSelectedBoltMaterial] = useState('');
    const [numberOfBolts, setNumberOfBolts] = useState('');
    const [selectedBoltDiameter, setSelectedBoltDiameter] = useState(0);
    const [yokeDesignId, setYokeDesignId] = useState('');
    const [valueOfp, setValueOfP] = useState('');
    const [valueOfh, setValueOfH] = useState('');
    const [BM40, setBM40] = useState(0);

    const {
        register,
        handleSubmit,
        setValue,
        errors,
    } = useForm();


    useEffect(() => {

        //Get Manual Gates data

        setLoader(true)
        if (isEditFlag || isViewFlag || ShutterId) {
            getYokeDesignData(ShutterId, (res) => {
                //
                if (res && res.data && res.data.Result) {
                    let Data = res.data.Data;

                    setTimeout(() => {
                        setCase1L(Data.LengthForAllowableDeflection);
                        setMaterialOfConstruction(Data.SelectedMaterialOfConstructionYoke);
                        setYokeSection(Data.SelectedYokeSection);
                        setThicknessOfSection(Data.SelectedYokeThickness);
                        setSelectedBoltDiameter(Data.SelectedBoltDiameterYokeMounting);
                        setSelectedBoltMaterial(Data.SelectedBoltMaterialYokeMounting);
                        setNumberOfBolts(Data.TotalNumberOfBoltYokeMounting);
                        setYokeDesignId(Data.YokeDesignId);
                        setBM40(Data.TandemSpindleConsiderda);

                        if (Data.SelectedYokeSection) {
                            setValueOfH(Data.YokeSectionH)
                            setValueOfP(Data.YokeSectionP)
                        }

                        setValue([
                            { 'L1': Data.LengthForAllowableDeflection },
                            { 'NumberOfBolt': Data.TotalNumberOfBoltYokeMounting },
                            { 'MaterialOfConstruction': Data.SelectedMaterialOfConstructionYoke },
                            { 'YokeSection': Data.SelectedYokeSection },
                            { 'BoltDiameter': Data.SelectedBoltDiameterYokeMounting },
                            { 'BoltMaterial': Data.SelectedBoltMaterialYokeMounting },
                            { 'ThicknessOfSection': Data.SelectedYokeThickness },
                            { 'consider': Data.TandemSpindleConsiderda },
                            { 'valueOfH': Data.YokeSectionH },
                            { 'valueOfP': Data.YokeSectionP }
                        ])
                        setLoader(false)
                    }, 100)
                }
            })
        } else {
            setLoader(false)
        }
    }, [])

    const MOCDataArray = [
        { label: 'Stainless Steel 304/304L Dual Certified', value: 'Stainless Steel 304/304L Dual Certified' },
        { label: 'Stainless Steel 316/316L Dual Certified', value: 'Stainless Steel 316/316L Dual Certified' },
        { label: 'Carbon Steel', value: 'Carbon Steel' },
        { label: 'Aluminium', value: 'Aluminium' },
    ]

    const yokeSectionDataArray = [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
    ]

    const thicknessOfSectionDataArray = [
        { label: '4', value: '4' },
        { label: '5', value: '5' },
        { label: '6', value: '6' },
        { label: '6.35', value: '6.35' },
        { label: '8', value: '8' },
        { label: '10', value: '10' },
        { label: '12', value: '12' },
        { label: '16', value: '16' },
        { label: '20', value: '20' },
    ]

    const BoltMaterialDataArray = [
        { label: 'Stainless Steel 304/304L Dual Certified', value: 'Stainless Steel 304/304L Dual Certified' },
        { label: 'Stainless Steel 316/316L Dual Certified', value: 'Stainless Steel 316/316L Dual Certified' },
        { label: 'Carbon Steel', value: 'Carbon Steel' }
    ]

    const BoltDiameterDataArray = () => [
        { label: '12', value: '12' },
        { label: '16', value: '16' },
        { label: '20', value: '20' },
        { label: '24', value: '24' },
        { label: '30', value: '30' },
        { label: '36', value: '36' },
    ]

    const valueOfH = () => {
        switch (yokeSection) {
            case 'A':
                return 190
            case 'B':
                return 250
            case 'C':
                return 250
            case 'D':
                return <TeInput
                    type='number'
                    register={register()}
                    onChange={(e) => setValueOfH(e.target.value)}
                    name='valueOfH'
                    readOnly={isViewFlag}
                />
            default:
                return 0
        }
    }

    const valueOfP = () => {
        switch (yokeSection) {
            case 'A':
                return 100
            case 'B':
                return 150
            case 'C':
                return 175
            case 'D':
                return <TeInput
                    type='number'
                    register={register()}
                    onChange={(e) => setValueOfP(e.target.value)}
                    name='valueOfP'
                    readOnly={isViewFlag}
                />
            default:
                return 0
        }
    }

    const valueOfQ = () => {
        switch (yokeSection) {
            case 'A':
                return 60
            case 'B':
                return 80
            case 'C':
                return 80
            case 'D':
                return 0
            default:
                return 0
        }
    }

    useEffect(() => {
        setValueOfH(valueOfH())
        setValueOfP(valueOfP())
    }, [yokeSection])

    const AWWAPermissibleDeflection = 6.40;
    const selectedSpindle = selectedSpindleType === "SINGLE SPINDLE" ? 1 : 2

    const deflectionAtCenter = () => {
        if (selectedSpindle === 2) {
            return <p>W x a (3 x L<sup>2</sup> - 4 x a<sup>2</sup>)/(24 x E x I) mm</p>
        } else {
            return 'W x L3 / (48 x E x I)'
        }
    }

    const actuation = selectedActuation === 'MANUAL' ? 0 : 1

    const hoistingForce = () => {

        // =IF(E22=0,(AF86*1000),AU86*1000)

        if (actuation == 0) {
            let hoistingcapacity = manuallyHoistingCapacity
            return hoistingcapacity * 1000
        } else {
            let hoistingcapacity = electricallyHoistingCapacity

            return hoistingcapacity * 1000
        }
    }

    const forceMaximumEffortOperator = () => {
        if (actuation !== '' && actuation !== null && actuation !== undefined) {
            if (actuation == 0) {
                return safetyFactor
            } else {
                return checkForNull(criticalBulkingForce)
            }
        } else {
            return 0
        }
    }

    const lengthOfSpan = () => width + 150

    const modulusOfElasticity = () => {
        switch (materialOfConstruction) {
            case 'Stainless Steel 304/304L Dual Certified':
                return 199950
            case 'Stainless Steel 316/316L Dual Certified':
                return 199950
            case 'Carbon Steel':
                return 199950
            case 'Aluminium':
                return 68950
            default:
                return 0
        }
    }

    const BI147 = valueOfp;
    const BI146 = valueOfh;
    const BI148 = parseFloat(thicknessOfSection);
    const BI149 = parseFloat(BI146) - parseFloat(BI148) - parseFloat(BI148);
    const BF106 = valueOfh ? valueOfh : parseFloat(valueOfH())
    const BF107 = parseFloat(BI148)
    const BF108 = valueOfp ? valueOfp : parseFloat(valueOfP());
    const BF109 = parseFloat(valueOfQ());
    const BH111 = BF106 * BF107
    const BH112 = (BF108 - 2 * BF107) * BF107
    const BH113 = BF109 * BF107
    const BH114 = BH112
    const BH115 = BF109 * BF107
    const BJ120 = BH111 + BH112 + BH113 + BH114 + BH115;
    const BH120 = (BH111 * 0.5 * BF107) + (BH112 * 0.5 * BF108) + (BH113 * (BF108 - 0.5 * BF107)) +
        (BH114 * 0.5 * BF108) + (BH115 * (BF108 - 0.5 * BF107))
    const BH121 = BH120 / BJ120
    const BG124 = (BF106 * Math.pow(BF107, 3) / 12) + BH111 * Math.pow(BH121 - 0.5 * BF107, 2)
    const BG127 = (BF107 * Math.pow((BF108 - BF107 * 2), 3) / 12) + BH112 * Math.pow(BH121 - 0.5 * BF108, 2)
    const BG130 = (BF109 * Math.pow(BF107, 3) / 12) + BH113 * Math.pow(BH121 - (BF108 - 0.5 * BF107), 2)
    const BG133 = BG127
    const BG136 = BG130
    const BG140 = BG124 + BG127 + BG130 + BG133 + BG136
    const BJ153 = ((BI147 * Math.pow(BI146, 3) / 12) - (((BI147 - BI148) * Math.pow(BI149, 3)) / 12)) * 2

    const BJ38 = hoistingForce();
    const BJ40 = lengthOfSpan();
    const BJ41 = modulusOfElasticity();


    const momentOfInertia = () => {
        if (yokeSection === 'D') {
            return BJ153
        } else {
            return BG140
        }
    }
    const BJ42 = momentOfInertia();
    const BQ39 = parseFloat(BJ38) * parseFloat(BM40) * (3 * Math.pow(parseFloat(BJ40), 2) - 4 * Math.pow(parseFloat(BM40), 2)) / (24 * parseFloat(BJ41) * parseFloat(BJ42));
    const BP39 = BJ38 * Math.pow(BJ40, 3) / (48 * BJ41 * BJ42)

    const BI150 = BI147
    const BL150 = parseFloat(thicknessOfSection)
    // const BI149 = BI146 - BL150 - BL150
    const BL149 = BL150
    const BJ154 = (((BI150 * BL150) * (BL150 + BI149 + (BL149 / 2))) + ((BI149 * BL149) * (BL150 + (BI149 / 2))) + ((BI150 * BL150) * (BL150 / 2))) / ((BI149 * BL149) + (BI150 * BL150) + (BI150 * BL150))
    const BJ155 = BJ153 / BJ154
    const BJ121 = BF108 - BH121
    const BJ152 = ((BI149 * BL149) + (BI150 * BL150) + (BI150 * BL150)) * 2

    const sectionModulus = () => {
        if (yokeSection === 'D') {
            return BJ155
        } else {
            return BJ42 / BJ121
        }
    }


    const maxDeflection = () => {
        if (selectedSpindle == 2) {
            return BQ39
        } else {
            return BP39
        }
    }

    const allowableDeflectionOFYoke = () => {
        return (width + 150) / case1L
    }

    const caseMaxDeflection = () => {
        const BJ39 = forceMaximumEffortOperator();
        if (selectedSpindle === 2) {
            return BJ39 * BM40 * (3 * Math.pow(BJ40, 2) - 4 * Math.pow(BM40, 2)) / (24 * BJ41 * BJ42)
        } else {
            return BJ39 * Math.pow(BJ40, 3) / (48 * BJ41 * BJ42)
        }
    }

    const allowableDeflectionOFYokeCase2 = () => {
        return (width + 150) * 1.33 / case1L
    }

    const maximumBendingMoment = () => {
        // =IF(E18=1,(BJ38*BJ40)/4,(BJ38*BM40)) 
        // =IF(E18=1,(BJ38*BJ40)/4,(BJ38*BM40))
        if (selectedSpindleType === 'SINGLE SPINDLE') {
            return hoistingForce() * lengthOfSpan() / 4
        }
        else {
            return hoistingForce() * BM40
        }
    }

    const maximumBendingStress = () => {
        return maximumBendingMoment() / sectionModulus()
    }

    const allowableBendingStress = () => {
        // =VLOOKUP($BJ$25,$BP$48:$BW$52,6,0)
        switch (materialOfConstruction) {
            case 'Aluminium':
                return Math.min(2 * 241 / 3, 2 * 290 / 5);
            case 'Carbon Steel':
                return Math.min(2 * 250 / 3, 2 * 410 / 5);
            case 'Stainless Steel 304/304L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 517 / 5);
            case 'Stainless Steel 316/316L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 517 / 5);
            default:
                return 0
        }
    }

    const allowableBendingStressCase1 = () => {
        // =VLOOKUP($BJ$25,$BP$48:$BW$52,5,0)
        switch (materialOfConstruction) {
            case 'Aluminium':
                // =MIN(BQ52/2,BR52/5)
                return Math.min(241 / 2, 290 / 5);
            case 'Carbon Steel':
                // =MIN(BQ49/2,BR49/5)
                return Math.min(250 / 2, 410 / 5);
            case 'Stainless Steel 304/304L Dual Certified':
                // =MIN(BQ50/2,BR50/5)
                return Math.min(207 / 2, 517 / 5);
            case 'Stainless Steel 316/316L Dual Certified':
                // =MIN(BQ51/2,BR51/5)
                return Math.min(207 / 2, 517 / 5);
            default:
                return 0
        }
    }

    const sectionalArea = () => {
        if (yokeSection === 'D') {
            return BJ152
        } else {
            return BJ120
        }
    }

    const shearStress = () => hoistingForce() / sectionalArea()

    const allowableSheerStress = () => {
        // =VLOOKUP($BJ$25,$BP$48:$BW$52,7,0)
        // change here
        switch (materialOfConstruction) {
            case 'Aluminium':
                // =MIN(BQ52/2,BS52/5)
                return Math.min(241 / 2, 186 / 5);
            case 'Carbon Steel':
                // =MIN(BQ49/2,BS49/5)
                return Math.min(250 / 2, 210 / 5);
            case 'Stainless Steel 304/304L Dual Certified':
                // =MIN(BQ50/2,BS50/5)
                return Math.min(207 / 2, 276 / 5);
            case 'Stainless Steel 316/316L Dual Certified':
                // =MIN(BQ51/2,BS51/5)
                return Math.min(207 / 2, 276 / 5);
            default:
                return 0
        }
    }

    const allowableSheerStressCase2 = () => {
        // =VLOOKUP($BJ$25,$BP$48:$BW$52,8,0)
        // change here
        switch (materialOfConstruction) {
            case 'Aluminium':
                // =MIN(2*BQ52/3,2*BS52/5)
                return 74.4
            case 'Carbon Steel':
                return 84
            case 'Stainless Steel 316/316L Dual Certified':
                return 110.4
            case 'Stainless Steel 304/304L Dual Certified':
                return 110.4
            default:
                return 0
        }
    }

    const maximumBendingMomentCase2 = () => {

        // =IF(E18=1,(BJ39*BJ40)/4,(BJ39*BM40))
        // =IF(E18=1,(forceMaximumEffortOperator*lengthOfSpan())/4,(forceMaximumEffortOperator()*BM40))  

        if (selectedSpindleType === 'SINGLE SPINDLE') {
            return forceMaximumEffortOperator() * lengthOfSpan() / 4
        }
        else {
            return forceMaximumEffortOperator() * BM40
        }
        // return (forceMaximumEffortOperator() * lengthOfSpan()) / 4
    }

    const maximumBendingStressCase2 = () => {
        return maximumBendingMomentCase2() / sectionModulus()
    }

    const shearStressCase2 = () => {
        return forceMaximumEffortOperator() / sectionalArea()
    }

    const sectionalAreaBoltDesign = () => {
        if (selectedBoltDiameter) {
            const diameterOFSelectedBolt = selectedBoltDiameter.toString();
            switch (diameterOFSelectedBolt) {
                case '12':
                    return 85
                case '16':
                    return 156.70
                case '20':
                    return 244.80
                case '24':
                    return 352.50
                case '30':
                    return 560.60
                case '36':
                    return 816.70
                default:
                    return 0
            }
        } else {
            return 0
        }
    }

    const load = () => parseFloat(hoistingForce()) > parseFloat(forceMaximumEffortOperator()) ? hoistingForce() : forceMaximumEffortOperator()

    const tensileStress = () => {
        return load() / (numberOfBolts * sectionalAreaBoltDesign())
    }

    const allowableTensileStress = () => {
        // =VLOOKUP($BJ$94,$BP$49:$BW$52,6,0)

        switch (materialOfConstruction) {
            case 'Aluminium':
                return Math.min(2 * 241 / 3, 2 * 186 / 5);
            case 'Carbon Steel':
                return Math.min(2 * 250 / 3, 2 * 210 / 5)
            case 'Stainless Steel 316/316L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 276 / 5)
            case 'Stainless Steel 304/304L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 276 / 5)
            default:
                return 0
        }
    }

    const allowableTensileStressFin = () => {
        // =VLOOKUP($BJ$94,$BP$49:$BW$52,6,0)

        switch (selectedBoltMaterial) {
            case 'Aluminium':
                return Math.min(2 * 241 / 3, 2 * 290 / 5);
            case 'Carbon Steel':
                return Math.min(2 * 290 / 3, 2 * 410 / 5)
            case 'Stainless Steel 316/316L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 207 / 5)
            case 'Stainless Steel 304/304L Dual Certified':
                return Math.min(2 * 207 / 3, 2 * 517 / 5)
            default:
                return 0
        }
    }

    const onSubmit = (values) => {
        if (
            // (
            //     (
            //         (maxDeflection() < allowableDeflectionOFYoke() &&
            //             applicableStandard === "IS-5620") ||
            //         (maxDeflection() < allowableDeflectionOFYoke() &&
            //             applicableStandard === "BS-7775") ||
            //         (maxDeflection() < AWWAPermissibleDeflection &&
            //             maxDeflection() < allowableDeflectionOFYoke() &&
            //             applicableStandard === "AWWA-C561")
            //     )
            //     &&
            //     (
            //         (caseMaxDeflection() < AWWAPermissibleDeflection &&
            //             caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
            //             applicableStandard === "AWWA-C561") ||
            //         (caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
            //             applicableStandard === "BS-7775") ||
            //         (caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
            //             applicableStandard === "IS-5620")
            //     )
            //     &&
            //     tensileStress() < allowableTensileStressFin()
            //     &&
            //     maximumBendingStress() < allowableBendingStress()
            //     && shearStress() < allowableSheerStress()
            //     &&
            //     maximumBendingStressCase2() < allowableBendingStress()
            //     &&
            //     shearStressCase2() < allowableSheerStress())

            ((maxDeflection() < AWWAPermissibleDeflection &&
                maxDeflection() < allowableDeflectionOFYoke() &&
                applicableStandard === "AWWA-C561" || applicableStandard === "AWWA-C560" || applicableStandard === "AWWA-C562"
            ) ||
                (
                    maxDeflection() < allowableDeflectionOFYoke() &&
                    applicableStandard === "BS-7775"
                ) ||
                (
                    maxDeflection() < allowableDeflectionOFYoke() &&
                    applicableStandard === "IS-5620" || applicableStandard === "IS-13349"
                )
            )
            &&
            (
                (caseMaxDeflection() < AWWAPermissibleDeflection &&
                    caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                    applicableStandard === "AWWA-C561" || applicableStandard === "AWWA-C560" || applicableStandard === "AWWA-C562"
                ) ||
                (
                    caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                    applicableStandard === "BS-7775"
                ) ||
                (
                    caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                    applicableStandard === "IS-5620" || applicableStandard === "IS-13349"
                )
            )
            &&
            maximumBendingStress() < allowableBendingStress()
            &&
            shearStress() < allowableSheerStress()
            &&
            maximumBendingStressCase2() < allowableBendingStress()
            &&
            shearStressCase2() < allowableSheerStress()
            &&
            tensileStress() < allowableTensileStressFin()
        ) {
            let formatedData = {
                ShutterDesignCalculationId: shutterDesignId,
                SelectedMaterialOfConstructionYoke: materialOfConstruction,
                SelectedYokeSection: yokeSection,
                SelectedYokeThickness: thicknessOfSection,
                LengthForAllowableDeflection: case1L,
                SelectedBoltMaterialYokeMounting: selectedBoltMaterial,
                TotalNumberOfBoltYokeMounting: numberOfBolts,
                SelectedBoltDiameterYokeMounting: selectedBoltDiameter,
                AllowableTensileStress: allowableTensileStressFin().toFixed(2),
                CreatedBy: loggedInUserId(),
                loggedInUserId: loggedInUserId(),
                TandemSpindleConsiderda: BM40,
                YokeSectionH: yokeSection === 'D' ? valueOfh : null,
                YokeSectionP: yokeSection === 'D' ? valueOfp : null,
                YokeSectionQ: valueOfQ()
            }

            if (isEditFlag) {
                formatedData = {
                    ...formatedData, YokeDesignId: yokeDesignId,
                    ShutterDesignCalculationId: ShutterId
                }

                updateYokeDesign(formatedData, res => {
                    if (res.status === 200) {
                        toastr.success('Yoke Design is updated successfully.')
                        toggle('1')
                        shutterIdNewCreated('')
                        resetTabs();
                    }
                })
            } else {
                setYokeDesignData(formatedData, res => {
                    if (res.status === 200) {
                        toastr.success('Yoke Design is created successfully.')
                        toggle('1')
                        shutterIdNewCreated('')
                        resetTabs();
                    }
                })
            }
        } else {
            toastr.warning('Your design is unsafe, Please check all the values once again.')
        }
    }

    const required = () => {
        return checkForNull((lengthOfSpan() - (lengthOfSpan() * .8)) / 2)
    }

    return (
        <Container fluid className="cr-yoke-container cr-table-wrap">
            {isLoader && <Loader />}
            <div className="shutter-design">
                <div className="form-heading">
                    <h2>Yoke Design</h2>
                </div>
                <Row className="mb-3">
                    <Col md="2">
                        <p>DATED</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{moment(date).format("DD-MM-YYYY")}</p>
                    </Col>
                    {/* <Col md="4">
                        <p>GATE SIZE</p>
                    </Col>
                    <Col md="2">
                        <p>0</p>
                    </Col> */}
                    <Col md="2">
                        <p>CLIENT</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{client}</p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md="2">
                        <p>LOCATION</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{location}</p>
                    </Col>
                    <Col md="2">
                        <p>PROJECT</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{project}</p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col md="2">
                        <p>TAG NO.</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{tag_number}</p>
                    </Col>
                    <Col md="2">
                        <p>REVISION NO.</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{rev_number}</p>
                    </Col>
                </Row>
                {/* <Row>
                    <Col md="2">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>REFERENCE DRAWING NO.</p>
                    </Col>
                    <Col md="2">
                        <p>{'--------------'}</p>
                    </Col>
                </Row> */}
                {/* <Row>
                    <Col md="2">
                        <p>{''}</p>
                    </Col>
                    <Col md="4">
                        <p>{''}</p>
                    </Col>
                   
                </Row> */}
                <Row className="mb-3">
                    <Col md="2">
                        <p>{""}</p>
                    </Col>
                    <Col md="4">
                        <p>{""}</p>
                    </Col>
                    <Col md="2">
                        <p>REVISION DATE</p>
                    </Col>
                    <Col md="1">:</Col>
                    <Col md="3">
                        <p>{rev_date ? moment(rev_date).format("DD-MM-YYYY") : '-'}</p>
                    </Col>
                </Row>
                <form
                    noValidate
                    className="form"
                    onSubmit={handleSubmit(onSubmit)}
                    autoComplete="off"
                    onKeyPress={(e) => onKeyPress(e)}
                >
                    <Row className={'mt-4 mb-2'}>
                        <Col md="12">
                            <div className={'page-heads'}>
                                Design of Yoke:
                            </div>
                            <div className={'page-heads'}>
                                <p>
                                    The yoke is designed as a a simply supported beam with concentrated load at axis of spindle. For this condition the deflection of yoke shall not be greater than L/360 or a maximum of 6.4 mm at maximum operating load. For design of yoke we consider maximum force that can come due to stalling of actuator or the maximum effort applied by operator.
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="4">
                            <img src={require('../../images/Yoke1.png')} />
                            {/* <img src='https://jel.costitright.com/Yoke1.png' /> */}
                        </Col>
                        <Col md="4">
                            <img src={require('../../images/Yoke-2.png')} />
                        </Col>
                        <Col md="4">
                            <img src={require('../../images/Yoke-3.png')} />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Material of construction of Yoke'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="3">
                            <TeSelect
                                name='MaterialOfConstruction'
                                register={register({ required: true })}
                                errors={errors}
                                dataArray={MOCDataArray}
                                onChange={(val) => setMaterialOfConstruction(val)}
                                disabled={isViewFlag}
                            />
                        </Col>
                        <Col md="3">
                            <p>{''}</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'We consider yoke section '}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="2">
                            <TeSelect
                                name='YokeSection'
                                register={register({ required: true })}
                                errors={errors}
                                dataArray={yokeSectionDataArray}
                                onChange={(val) => setYokeSection(val)}
                                disabled={isViewFlag}
                            />
                        </Col>
                        <Col md="3">
                            <p>{''}</p>
                        </Col>
                    </Row>
                    <Row className="mb-3"><Col md='12'>Where,</Col></Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'H'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="2" className="max-width-container">
                            {valueOfH()}<span className={`unit-display ${yokeSection==='D' ? " " : "d-none"}`}>mm</span> <span className={`${yokeSection==='D' ? "d-none" : ""}`}>mm </span>
                        </Col>
                        <Col md="12"></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'P'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="2">
                            {valueOfP()}<span className={`unit-display ${yokeSection==='D' ? " " : "d-none"}`}>mm</span> <span className={`${yokeSection==='D' ? "d-none" : ""}`}>mm </span>
                        </Col>
                        <Col md="12"></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Q'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="2">
                            {valueOfQ()}{' mm'}
                        </Col>
                        <Col md="12"></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'We consider thickness of section'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'t ='}</p>
                        </Col>
                        <Col md="2">
                            <TeSelect
                                name='ThicknessOfSection'
                                register={register({ required: true })}
                                errors={errors}
                                dataArray={thicknessOfSectionDataArray}
                                onChange={(val) => setThicknessOfSection(val)}
                                disabled={isViewFlag}
                            />
                        </Col>
                        <Col md="3" className="cr-mm-dimension">
                            <p>{'mm'}</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Max. deflection at the centre'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="5">
                            {deflectionAtCenter()}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Where,'}</p>
                        </Col>
                        <Col md="2">
                            <p>{''}</p>
                        </Col>
                        <Col md="2">

                        </Col>
                        <Col md="3">
                            <p>{''}</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'W1 = Hoisting Force  (Load Case 1)'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="5">
                            {checkForNull(hoistingForce()).toFixed(0)} {" N"}
                        </Col>
                    </Row>
                    {selectedSpindleType === 'TANDEM SPINDLE' ?
                        <Row className="mb-3">
                            <Col md="5">
                                <p>{'W2 = Force due to maximum effort of operator (Load Case 2)'}</p>
                            </Col>
                            <Col md="2" className='text-right'>
                                =
                            </Col>
                            <Col md="1">
                                {checkForNull(forceMaximumEffortOperator()).toFixed(0)}{" N"}
                            </Col>
                            <Col md="1">
                                REQUIRED
                            </Col>
                            <Col md="2">
                                CONSIDERED
                            </Col>
                        </Row> :
                        <Row className="mb-3">
                            <Col md="5">
                                <p>{'W2 = Force due to maximum effort of operator (Load Case 2)'}</p>
                            </Col>
                            <Col md="2" className='text-right'>
                                =
                            </Col>
                            <Col md="5">
                                {checkForNull(forceMaximumEffortOperator()).toFixed(0)} {" N"}
                            </Col>
                        </Row>
                    }
                    {selectedSpindleType === 'TANDEM SPINDLE' ?
                        <Row className="mb-3">
                            <Col md="5">
                                <p>{'L = Length of span = ( Length of Yoke + 150 mm)'}</p>
                            </Col>
                            <Col md="2" className='text-right'>
                                =
                            </Col>
                            <Col md="1">
                                {checkForNull(lengthOfSpan()).toFixed(0)} mm Where
                            </Col>
                            <Col md="1">
                                {required().toFixed(0)}
                            </Col>
                            <Col md="3">
                                <TeInput
                                    name='consider'
                                    type='number'
                                    register={register({ required: true })}
                                    errors={errors}
                                    onChange={(e) => setBM40(parseFloat(e.target.value))}
                                    readOnly={isViewFlag}

                                />
                            </Col>
                        </Row>
                        :
                        <Row className="mb-3">
                            <Col md="5">
                                <p>{'L = Length of span = ( Length of Yoke + 150 mm)'}</p>
                            </Col>
                            <Col md="2" className='text-right'>
                                =
                            </Col>
                            <Col md="2">
                                {checkForNull(lengthOfSpan())}{' mm'}
                            </Col>
                        </Row>
                    }
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'E = Modulus of elasticity of selected material'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(modulusOfElasticity()).toFixed(0)}  mm<sup>2</sup>
                        </Col>
                        <Col md="3">

                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'I = Moment of Inertia for selected section'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(momentOfInertia()).toFixed(0)} mm<sup>4</sup>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Z = Section Modulus for selected section'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(sectionModulus()).toFixed(0)} mm<sup>3</sup>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Max. deflection at the centre for Load Case 1'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="5">
                            {deflectionAtCenter()}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Therefore, Max. deflection at the centre'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            <p>{'='}</p>
                        </Col>
                        <Col md="2">
                            {checkForNull(maxDeflection()).toFixed(3)} {" mm"}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                        </Col>
                        <Col md="2">
                        </Col>
                        <Col md="2">
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            {'The allowable deflection of Yoke'}
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {'Span / L '}
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {'(W + 150)/ L'}
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Where,'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            L =
                        </Col>
                        <Col md="3" className="d-flex align-items-center">
                            <TeInput
                                name='L1'
                                type='number'
                                register={register({ required: true })}
                                errors={errors}
                                onChange={(e) => setCase1L(e.target.value)}
                                readOnly={isViewFlag}
                            /><p className="ml-1"> mm</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'But as per AWWA Permissible deflection not to exceed'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="3">
                            6.40{' mm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Hence,The allowable deflection of Yoke'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="4">
                            {checkForNull(allowableDeflectionOFYoke()).toFixed(2)}{' mm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>
                                {
                                    (maxDeflection() < AWWAPermissibleDeflection &&
                                        maxDeflection() < allowableDeflectionOFYoke() &&
                                        applicableStandard === "AWWA-C561" || applicableStandard === "AWWA-C560" || applicableStandard === "AWWA-C562"
                                    ) ?
                                        'Since maximum deflection of yoke is less than permissible deflection as per AWWA, the design is safe.'
                                        :
                                        (
                                            maxDeflection() < allowableDeflectionOFYoke() &&
                                            applicableStandard === "BS-7775"
                                        ) ?
                                            "Since maximum deflection of yoke is less than permissible deflection, Hence the design is safe."
                                            :
                                            (
                                                maxDeflection() < allowableDeflectionOFYoke() &&
                                                applicableStandard === "IS-5620" || applicableStandard === "IS-13349"
                                            ) ?
                                                "Since maximum deflection of yoke is less than permissible deflection, Hence the design is safe."
                                                :
                                                <p className='error'>Design is Un-safe, Please re-design.</p>
                                }
                            </p>
                        </Col>
                    </Row>
                    <Row className="mb-3"></Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Max. deflection at the centre for Load Case 2'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="5">
                            {deflectionAtCenter()}
                        </Col>

                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Therefore, Max. deflection at the centre'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="3">
                            {checkForNull(caseMaxDeflection()).toFixed(3)}{' mm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'The allowable deflection of Yoke'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="4">
                            {'Span / L  '}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{''}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {'( W + 150 )x 1.33/ L'}
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Where,'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            L =
                        </Col>
                        <Col md="2">
                            {/* <TeInput
                                name='L2'
                                type='number'
                                onChange={(e) => setCase2L(e.target.value)}
                            /> */}
                            {case1L}
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'But as per AWWA Permissible deflection not to exceed'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="5">
                            {AWWAPermissibleDeflection}{' mm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Hence,The allowable deflection of Yoke'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(allowableDeflectionOFYokeCase2()).toFixed(2)}{' mm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                (caseMaxDeflection() < AWWAPermissibleDeflection &&
                                    caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                                    applicableStandard === "AWWA-C561" || applicableStandard === "AWWA-C560" || applicableStandard === "AWWA-C562"
                                ) ?
                                    'Since maximum deflection of yoke is less than permissible deflection as per AWWA, the design is safe.'
                                    :
                                    (
                                        caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                                        applicableStandard === "BS-7775"
                                    ) ?
                                        "Since maximum deflection of yoke is less than permissible deflection, Hence the design is safe."
                                        :
                                        (
                                            caseMaxDeflection() < allowableDeflectionOFYokeCase2() &&
                                            applicableStandard === "IS-5620" || applicableStandard === "IS-13349"
                                        ) ?
                                            "Since maximum deflection of yoke is less than permissible deflection, Hence the design is safe."
                                            :
                                            <p className='error'>Design is Un-safe, Please re-design.</p>
                            }</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p><u>{'Check for bending for Load case 1'}</u></p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Maximum bending moment'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(maximumBendingMoment()).toFixed(0)}{' Nmm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Maximum bending Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(maximumBendingStress()).toFixed(2)}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Allowable bending Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {allowableBendingStressCase1()}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                maximumBendingStress() < allowableBendingStress() ?
                                    "The applied stress is below the allowable stress of the material."
                                    :
                                    <p className='error'>"The design stress exceeds the allowable stress of the material. Further evaluation is recommended."</p>
                            }</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p><u>{'Check for Shear for Load case 1'}</u></p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Sectional Area'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(sectionalArea()).toFixed(2)}  mm<sup>2</sup>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Max Shear Force'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(hoistingForce()).toFixed(0)} N
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Shear stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(shearStress()).toFixed(2)}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Allowable Shear Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {allowableSheerStress()}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                shearStress() < allowableSheerStress() ?
                                    "The applied stress is below the allowable stress of the material."
                                    :
                                    <p className='error'>"The design stress exceeds the allowable stress of the material. Further evaluation is recommended."</p>
                            }</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p><u>{"Check for bending for Load case 2"}</u></p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Maximum bending moment'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {maximumBendingMomentCase2().toFixed(0)}{' Nmm'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Maximum bending Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(maximumBendingStressCase2()).toFixed(0)}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Allowable bending Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {allowableBendingStress()}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                maximumBendingStressCase2() < allowableBendingStress() ?
                                    'The applied stress is below the allowable stress of the material.'
                                    :
                                    <p className='error'> "The design stress exceeds the allowable stress of the material. Further evaluation is recommended."</p>
                            }</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p><u>{'Check for Shear for Load case 2'}</u></p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Sectional Area'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(sectionalArea()).toFixed(2)} mm<sup>2</sup>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Max Shear Force'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(forceMaximumEffortOperator()).toFixed(0)} N
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Shear stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(shearStressCase2()).toFixed(2)}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Allowable Shear Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {allowableSheerStressCase2()}{' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                shearStressCase2() < allowableSheerStress() ?
                                    "The applied stress is below the allowable stress of the material."
                                    :
                                    <p className='error'> "The design stress exceeds the allowable stress of the material. Further evaluation is recommended." </p>
                            }</p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p><u>{"Bolt design for yoke mounting with frame"}</u></p>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Bolt material'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="3">
                            <TeSelect
                                name='BoltMaterial'
                                register={register({ required: true })}
                                errors={errors}
                                dataArray={BoltMaterialDataArray}
                                onChange={(val) => setSelectedBoltMaterial(val)}
                                disabled={isViewFlag}
                            />
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Total Number of bolts'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2" className="max-width-container2">
                            <TeInput
                                name='NumberOfBolt'
                                type='number'
                                register={register({ required: true })}
                                errors={errors}
                                onChange={(e) => setNumberOfBolts(e.target.value)}
                                readOnly={isViewFlag}
                            /><span className="unit-display2">mm</span>
                        </Col>

                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Bolt diameter'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2" className=" max-width-container">
                            <TeSelect
                                name='BoltDiameter'
                                register={register({ required: true })}
                                errors={errors}
                                dataArray={BoltDiameterDataArray()}
                                onChange={(val) => setSelectedBoltDiameter(val)}
                                disabled={isViewFlag}
                            /><span className="unit-display2">mm</span>
                        </Col>
                        <Col md="3">
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Sectional area'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="4">
                            {checkForNull(sectionalAreaBoltDesign()).toFixed(2)}  mm<sup>2</sup>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Load'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(load()).toFixed(2)}{" N"}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Tensile Stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="2">
                            {checkForNull(tensileStress()).toFixed(2)} {' Mpa'}
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="5">
                            <p>{'Allowable tensile stress'}</p>
                        </Col>
                        <Col md="2" className='text-right'>
                            =
                        </Col>
                        <Col md="4">
                            {allowableTensileStressFin().toFixed(2)}  Mpa
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md="12">
                            <p>{
                                tensileStress() < allowableTensileStressFin() ?
                                    "The applied stress is below the allowable stress of the material."
                                    :
                                    <p className='error'> The design stress exceeds the allowable stress of the material. Further evaluation is recommended </p>
                            }</p>
                        </Col>
                    </Row>
                    <hr className={'my-4'} />
                    {!isViewFlag && <div className={'text-right my-2'}>
                        <button className={'btn btn-primary'} type='submit'>Submit</button>
                    </div>
                    }
                </form>
            </div>
        </Container>
    )
}

const mapStateToProps = (state) => {
    const returnObj = {};
    const yokeData = state.desingMster.yokeSectionData;
    const {
        Client,
        Dated,
        Location,
        Project,
        RevisionDate,
        RevisionNumber,
        TagNumber,
        SelectedApplicableStandard,
        MaximumCriticalBucklingForce,
        SelectedActuation,
        MaxCompressiveForceDueToFactorOfSafety,
        HoistingCapacity,
        SizeWidth,
        SelectedSpindleType,
        ShutterDesignCalculationId
    } = yokeData

    returnObj.data = {
        date: Dated,
        client: Client,
        project: Project,
        location: Location,
        tag_number: TagNumber,
        rev_number: RevisionNumber,
        rev_date: RevisionDate,
        selectedSpindleType: SelectedSpindleType,
        applicableStandard: SelectedApplicableStandard,
        criticalBulkingForce: MaximumCriticalBucklingForce,
        selectedActuation: SelectedActuation,
        safetyFactor: MaxCompressiveForceDueToFactorOfSafety,
        manuallyHoistingCapacity: HoistingCapacity,
        electricallyHoistingCapacity: HoistingCapacity,
        width: SizeWidth,
        shutterDesignId: ShutterDesignCalculationId,
    }

    return returnObj;
};

export default connect(mapStateToProps, {
    setYokeDesignData,
    getYokeDesignData,
    updateYokeDesign
})(YokeDesign);